import React from 'react';
import "./Skills.css";
import HtmlImg from "../assets/html.png";
import CssImg from "../assets/css.png";
import JavascriptImg from "../assets/javascript.png";
import JqueryImg from "../assets/jQuery.png";
// import BootstrapImg from "../assets/bootStrap.svg";
import NodeImg from "../assets/node.png";
import MongodbImg from "../assets/mongoDb.png";
import ReactImg from "../assets/react.png";
import ReduxImg from "../assets/redux.png"
import GitImg from "../assets/git.png";
import MaterialuiImg from "../assets/mu5.png";
import ExpressImg from "../assets/expressjs.png";
import ReactrouterImg from "../assets/reactRouter.png";
import ReactcontextapiImg from "../assets/reactContextApi.webp"
import FirebaseImg from "../assets/fireBase.png";
import FirebaseauthenticationImg from "../assets/fireBaseAuthentication.webp";
import FirestoreImg from "../assets/cloudFireStore.png";
import TrophyImg from "../assets/trophyImg.png"

function Skills() {
  return (
    <div className='skp' id = "skills">
    <div className='skillsAndExperience'>
    <div className='skills'>
      <h1>SKILLS</h1>
      <div className='skills__row'>
        <div className='skill__image'>
          <div className='skill__container'>
           <img className="htmlImg" src={HtmlImg} alt="html" />
          </div>
        <p>HTML</p>
        </div>

        <div className='skill__image'>
          <div className='skill__container'>
           <img className="cssImg" src={CssImg} alt="css"/>
          </div>
        <p>CSS</p>
        </div >
        <div className='skill__image'>
          <div className='skill__container'>
        <img className="jsImg" src={JavascriptImg} alt="javascript"/>
          </div>
        <p>JAVASCRIPT</p>
        </div>
        <div className='skill__image'> 
        <div className='skill__container'>
        <img className="jqueryImg" src={JqueryImg} alt="jquery"/>
        </div>
        <p>JQUERY</p>
        </div>
        <div className='skill__image'>
          <div className='skill__container'>
        <img className="nodeImg" src={NodeImg} alt="html"/>
        </div>
        <p>NODEJS</p>
        </div>
        {/* <div className='skill__image'>
        <img className="reactImg" src={MongodbImg} alt="html"/>
        <p>MONGODB</p>
        </div> */}
      </div>

     <div className='skills__row'>
       <div className='skill__image'>
        <div className='skill__container'>
          <img className='reactImg' src={ReactImg} alt="html"/>
        </div>
        <p>REACTJS</p>
       </div>
       <div className='skill__image'>
       <div className='skill__container'>
         <img className='reduxImg' src={ReduxImg} alt="html"/>
        </div>
        <p>REDUX</p>
       </div>
       <div className='skill__image'>
        <div className='skill__container'>
        <img className='gitImg' src={GitImg} alt="html"/>
        </div>
        <p>GIT</p>
       </div>
      <div className='skill__image'>
        <div className='skill__container'>
       <img className='materialImg' src={MaterialuiImg} alt="html"/>
       </div>
       <p>MATERIALUI</p>
      </div>
      <div className='skill__image'>
        <div className='skill__container'>
       <img className='expImg' src={ExpressImg} alt="html"/>
       </div>
       <p>EXPRESS</p>
      </div>
      {/* <div className='skill__image'>
        <div className='skill__container'>
       <img className='reactrouterImg' src={ReactrouterImg} alt="html"/>
       </div>
       <p>REACT ROUTER</p>
      </div>     */}
     </div>

     <div className='skills__row'>
      {/* <div className='skill__image'>
      <img src={ReactcontextapiImg} alt="html"/>
      <p>CONTEXT API</p>
      </div> */}
      <div className='skill__image'>
      <img  className="firebaseImg" src={FirebaseImg} alt="html"/>
      <p>FIREBASE</p>
      </div>
      <div className='skill__image'>
      <img className="firebaseauthImg" src={FirebaseauthenticationImg} alt="html"/>
      <p>FIREBASE AUTH</p>
      </div>
      <div className='skill__image'>
      <img classname="firestoreImg" src={FirestoreImg} alt="html"/>
      <p>FIRESTORE</p>
      </div>
       <div className='skill__image'>
        <img className="mongodbImg" src={MongodbImg} alt="html"/>
        <p>MONGODB</p>
        </div>
     </div>
    </div>

    <div className='experience'>
       <h1>EXPERIENCE</h1>
      <img src={TrophyImg} alt="logo" />
      <p>November 2020-Present</p>
      <p>At TITAN</p>
    </div>
  </div>
  </div>
  )
}

export default Skills;